<template>
  <section>
    <b-field >
      <b-autocomplete
        v-model="cliente"
        id="cliente"
        placeholder="Escribe el NIT del cliente"
        :keep-first="true"
        :data="clientesFiltrados"
        field="nit"
        @input="buscarClientes"
        @select="seleccionarCliente"
        size="is-medium"
      >
        <template v-slot="{ option }">
          <div>
            <strong>{{ option.name }}</strong>  -
            {{ option.identification_number }}-{{ option.dv }}
          </div>
        </template>
      </b-autocomplete>
    </b-field>
    <div class="notification is-info mt-2" v-if="clienteSeleccionado">
      <button class="delete" @click="deseleccionarCliente"></button>
      <p>
        Nit: <b>{{ clienteSeleccionado.identification_number }}-{{ clienteSeleccionado.dv }}</b>
      </p>
      <p>
        Nombre: <b>{{ clienteSeleccionado.name }}</b>
      </p>
      <p>
        Correo: <b>{{ clienteSeleccionado.email }}</b>
      </p>
      <p>
        Teléfono: <b>{{ clienteSeleccionado.phone }}</b>
      </p>
    </div>
  </section>
</template>
  
  <script>

export default {
  name: "BusquedaCliente",

  data: () => ({
    cliente: "",
    clientesEncontrados: [],
    clienteSeleccionado: null,
  }),

  methods: {
    deseleccionarCliente() {
      this.clienteSeleccionado = null;
    },
    seleccionarCliente(opcion) {
      if (!opcion) return;
      this.clienteSeleccionado = opcion;
      this.$emit("seleccionado", this.clienteSeleccionado);
      setTimeout(() => (this.cliente = ""), 10);
    },

    buscarClientes() {
		console.log("Buscando clientes...");
      const payload = {
        accion: "obtener_por_nombre",
        nombre: this.cliente,
      };

      fetch("https://megapos.co/facturaElectronica/api/clientes.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Error en la petición");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Datos obtenidos:", data); // Verifica que `data` tenga los clientes correctamente
          this.clientesEncontrados = data;
        })
        .catch((error) => {
          console.error("Error al obtener clientes:", error);
        });
    },
  },

  computed: {
  clientesFiltrados() {
    if (!this.cliente) return this.clientesEncontrados; // Si el input está vacío, devuelve todos los clientes

    return this.clientesEncontrados.filter((opcion) => {
      const nombre = opcion.name
        ? opcion.name.toString().toLowerCase()
        : "";
      const documento = opcion.identification_number
        ? opcion.identification_number.toString().toLowerCase()
        : "";
      const nit = opcion.nit ? opcion.nit.toString().toLowerCase() : "";
      const cliente = this.cliente.toString().toLowerCase();

      return (
        nombre.includes(cliente) ||
        documento.includes(cliente) ||
        nit.includes(cliente)
      );
    });
  }
}

};
</script>
  